/**
 * Pack Duo gift lines: qty on the line up to _bp_gift_max_discounted_qty uses
 * the theme’s normal [+] (same line, discounted display). Once the line already
 * has that many units, further [+] adds the variant via /cart/add.js with no
 * bundle properties (separate full-price line).
 */
(function () {
  'use strict';

  function bpCartAddJsUrl() {
    var u = (window.routes && window.routes.cart_add_url) || '/cart/add';
    if (u.indexOf('.js') !== -1) return u;
    var base = u.split('?')[0];
    var q = u.indexOf('?') !== -1 ? u.slice(u.indexOf('?')) : '';
    if (/\/cart\/add$/i.test(base)) return base + '.js' + q;
    return base.replace(/\/?$/, '') + '.js' + q;
  }

  function bpSectionsForCartRequests() {
    var list = ['cart-drawer', 'cart-icon-bubble'];
    var mi = document.getElementById('main-cart-items');
    var mf = document.getElementById('main-cart-footer');
    if (mi && mi.dataset && mi.dataset.id) list.push(mi.dataset.id);
    if (mf && mf.dataset && mf.dataset.id) list.push(mf.dataset.id);
    var seen = {};
    return list.filter(function (id) {
      if (!id || seen[id]) return false;
      seen[id] = true;
      return true;
    });
  }

  function bpPickSectionHtml(sectionsObj, slugPart) {
    if (!sectionsObj || typeof sectionsObj !== 'object') return null;
    var direct = sectionsObj[slugPart];
    if (direct != null && direct !== '') return direct;
    var keys = Object.keys(sectionsObj);
    for (var i = 0; i < keys.length; i++) {
      var k = keys[i];
      if (k.indexOf(slugPart) !== -1 && sectionsObj[k] != null && sectionsObj[k] !== '') {
        return sectionsObj[k];
      }
    }
    return null;
  }

  function bpReplaceBySelectorId(htmlString, docSelectorId, targetEl) {
    if (!htmlString || !targetEl) return false;
    try {
      var doc = new DOMParser().parseFromString(htmlString, 'text/html');
      var src = doc.getElementById(docSelectorId);
      if (!src) return false;
      targetEl.innerHTML = src.innerHTML;
      return true;
    } catch (e) {
      return false;
    }
  }

  function bpSectionHtmlForEl(sections, el) {
    if (!sections || !el || !el.dataset || !el.dataset.id) return null;
    var sid = el.dataset.id;
    if (sections[sid]) return sections[sid];
    return bpPickSectionHtml(sections, el.id);
  }

  function bpSectionsUrl() {
    if (window.routes && window.routes.cart_url && document.body && document.body.classList.contains('template-cart')) {
      return window.routes.cart_url.split('?')[0];
    }
    return (window.location.pathname || '/').split('?')[0] || '/';
  }

  function bpSyncDrawerHostFromSectionHtml(drawerHtml) {
    try {
      var doc = new DOMParser().parseFromString(drawerHtml, 'text/html');
      var srcHost = doc.querySelector('cart-drawer');
      var destHost = document.querySelector('cart-drawer');
      if (!srcHost || !destHost) return;
      if (srcHost.classList.contains('is-empty')) destHost.classList.add('is-empty');
      else destHost.classList.remove('is-empty');
    } catch (e) {}
  }

  function bpRefreshCartUi() {
    var routes = window.routes || {};
    var cartUpdateUrl = routes.cart_update_url || '/cart/update.js';
    var sections = [];
    var mi = document.getElementById('main-cart-items');
    var mf = document.getElementById('main-cart-footer');
    if (mi && mi.dataset && mi.dataset.id) sections.push(mi.dataset.id);
    if (mf && mf.dataset && mf.dataset.id) sections.push(mf.dataset.id);
    sections.push('cart-drawer', 'cart-icon-bubble');
    var seen = {};
    sections = sections.filter(function (id) {
      if (!id || seen[id]) return false;
      seen[id] = true;
      return true;
    });

    return fetch(cartUpdateUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({
        updates: {},
        sections: sections,
        sections_url: bpSectionsUrl()
      })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart update failed');
        return r.json();
      })
      .then(function (body) {
        var sec = body.sections;
        if (!sec) return body;

        var cd = document.querySelector('cart-drawer');
        if (cd && typeof cd.renderContents === 'function') {
          try {
            cd.renderContents(body, true);
          } catch (e1) {
            var drawerHtml = bpPickSectionHtml(sec, 'cart-drawer');
            if (drawerHtml) {
              bpSyncDrawerHostFromSectionHtml(drawerHtml);
              var dest = document.querySelector('cart-drawer #CartDrawer');
              var doc = new DOMParser().parseFromString(drawerHtml, 'text/html');
              var srcNode = doc.querySelector('#CartDrawer');
              if (dest && srcNode) dest.innerHTML = srcNode.innerHTML;
            }
          }
        }

        var mm = bpSectionHtmlForEl(sec, mi);
        if (mi && mm) bpReplaceBySelectorId(mm, 'main-cart-items', mi);

        var fm = mf && bpSectionHtmlForEl(sec, mf);
        if (mf && fm) bpReplaceBySelectorId(fm, 'main-cart-footer', mf);

        var bubbleHtml = bpPickSectionHtml(sec, 'cart-icon-bubble');
        if (bubbleHtml) {
          var doc2 = new DOMParser().parseFromString(bubbleHtml, 'text/html');
          var wrap = doc2.querySelector('.shopify-section') || doc2.body;
          var bubble = document.getElementById('cart-icon-bubble');
          if (wrap && bubble) bubble.innerHTML = wrap.innerHTML;
        }

        if (typeof body.item_count === 'number') {
          var cartItemsEl = document.querySelector('cart-items');
          if (cartItemsEl) cartItemsEl.classList.toggle('is-empty', body.item_count === 0);
          if (mf) mf.classList.toggle('is-empty', body.item_count === 0);
        }

        return body;
      });
  }

  document.addEventListener(
    'click',
    function (e) {
      var btn = e.target && e.target.closest && e.target.closest('.quantity__button[name="plus"]');
      if (!btn) return;
      var line = e.target.closest('[data-bp-bundle-gift-line="true"]');
      if (!line) return;

      var qi = line.querySelector('quantity-input');
      var input = qi ? qi.querySelector('.quantity__input') : line.querySelector('.quantity__input');
      if (!input) return;

      if (!line.hasAttribute('data-bp-gift-max-discounted-qty')) {
        return;
      }
      var maxQty = parseInt(line.getAttribute('data-bp-gift-max-discounted-qty'), 10);
      if (isNaN(maxQty) || maxQty < 1) {
        return;
      }
      var currentQty = parseInt(input.value, 10) || 0;
      if (currentQty < maxQty) {
        return;
      }

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      var vid = input.getAttribute('data-quantity-variant-id');
      if (!vid) return;

      btn.setAttribute('disabled', 'disabled');
      var payload = {
        items: [{ id: parseInt(vid, 10), quantity: 1 }],
        sections: bpSectionsForCartRequests(),
        sections_url: bpSectionsUrl()
      };
      fetch(bpCartAddJsUrl(), {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        credentials: 'same-origin',
        body: JSON.stringify(payload)
      })
        .then(function (r) {
          return r.json().then(function (data) {
            return { ok: r.ok, data: data };
          });
        })
        .then(function (res) {
          if (!res.ok || (res.data && res.data.status)) {
            var msg = (res.data && (res.data.description || res.data.message)) || 'Could not update cart';
            throw new Error(msg);
          }
          var cd = document.querySelector('cart-drawer');
          if (cd && typeof cd.renderContents === 'function' && res.data && res.data.sections) {
            try {
              cd.renderContents(res.data, true);
              return res.data;
            } catch (eR) {
              /* fall through to fetch-based refresh */
            }
          }
          return bpRefreshCartUi();
        })
        .catch(function (err) {
          console.error(err);
        })
        .finally(function () {
          btn.removeAttribute('disabled');
        });
    },
    true
  );
})();
